import { render, staticRenderFns } from "./patientTag.vue?vue&type=template&id=bb86f798&scoped=true"
import script from "./patientTag.vue?vue&type=script&lang=js"
export * from "./patientTag.vue?vue&type=script&lang=js"
import style0 from "./patientTag.vue?vue&type=style&index=0&id=bb86f798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb86f798",
  null
  
)

export default component.exports